'use strict';

require('../shell/includes.js');
require('../../includes/modules.js');
require('../../includes/modulesCommon.js');
require('../../includes/companyData.js');
require('../../includes/graph.js');
require('../dashboard/appIncludes.js');
require('../../modules/props/channel.js');
require('./app.js');
require('./models/email.js');
require('./collections/email.js');
require('./data/emailSettings.js');
require('./views/email.js');
require('./views/accountEmail.js');
require('./views/emailList.js');
require('./views/emailListModal.js');
require('./views/setting.js');
require('./views/settings.js');
require('./views/emailTab.js');
require('./views/general.js');
require('./views/timezonePicker.js');
require('./views/fileUploadErrorModal.js');
require('./views/deleteCustomBrandingModal.js');
require('./views/revertDefaultBrandingModal.js');
require('./views/preview.js');
require('./views/branding.js');
require('./controller.js');
require('./views/delete.js');
require('./views/duplicate.js');
require('./views/renamingModal.js');
require('./views/shareLandscapeModal.js');
require('./bootstrap.js');
